import { h } from "preact"
import { useState } from "preact/hooks"
import { Button } from "../../../parts/buttons"
import useAuth from "../../../hooks/useAuth"

type Props = {
  show: boolean
  mutate: void
  onClose: void
}

const AddFeature = ({ mutate, show, onClose }: Props) => {
  const { fetcher } = useAuth()
  const [name, setName] = useState()

  const handleSubmit = (event) => {
    event.preventDefault()
    fetcher()
      .post("/list-feature", { name })
      .then(() => {
        mutate()
        onClose()
      })
  }

  return (
    <form
      className="modal-backdrop"
      style={{
        display: show ? "inherit" : "none",
        backgroundColor: "#00000099",
        overflowY: "auto",
      }}
      onSubmit={(event) => handleSubmit(event)}>
      <div class="modal-dialog modal-md modal-dialog-centered" role="document">
        <div class="modal-content card px-3 py-3">
          <div className="card-body text-center h5">Add New Feature</div>
          <div className="card-body">
            <div class="mb-4">
              <label class="form-label">Feature Name</label>
              <input
                type="text"
                class="form-control rounded mw-100"
                required
                value={name}
                onChange={({ currentTarget }) => setName(currentTarget.value)} />
            </div>
          </div>
          <div className="card-body d-flex justify-content-end">
            <Button onClick={onClose} type="button" variant="tertiary" className="m-1">
              Cancel
            </Button>
            <Button variant="primary" type="submit" className="m-1">
              Save
            </Button>
          </div>
        </div>
      </div>
    </form>
  )
}

export default AddFeature